'use strict';

var Panel = require('stb-component-panel'),
    keys  = require('stb-keys');


function getLang () {
    if ( PLATFORM === 'MAG' ) {
        return window.core.environment.language;
    }

    return navigator.language.split('-')[0];

}


function FakeInput ( config ) {

    /**
     *
     * @type {string}
     */
    this.value = config.value || '';

    this.placeholder = config.placeholder || '';

    this.size = config.size || 0;

    this.scheme = config.scheme || '';

    this.textVisible = true;

    this.$textVisibilityToggle = null;

    config.focusable = true;

    this.defaultEvents = FakeInput.defaultEvents;

    this.type = config.type || 'text';

    Panel.call(this, config);

    this.$node.classList.add(this.type);

    this.$body = this.$node.appendChild(document.createElement('div'));
    this.$body.className = 'fake-input-text-node';

    if ( this.value ) {
        this.$body.textContent = config.value;
    } else if ( this.placeholder ) {
        this.$node.classList.add('placeholder');
        this.$body.textContent = config.placeholder;
    }

    this.$node.classList.add('fake-input');

    if ( config.placeholder ) {
        this.$style = document.head.appendChild(document.createElement('style'));
        this.$style.textContent = '#' + this.$node.id + ':before { color: #23548c; content: "' + config.placeholder + '";}';
    }

    if ( this.type === 'password' ) {
        this.textVisible = false;
        this.$textVisibilityToggle = this.$node.appendChild(document.createElement('div'));
        this.$textVisibilityToggle.className = 'text-visibility-toggle';
        this.$textVisibilityToggle.focus = false;

        if ( !this.placeholder ) {
            this.$body.style.cssText = '-webkit-text-security: disc;';
        }
    }
}

// inheritance
FakeInput.prototype = Object.create(Panel.prototype);
FakeInput.prototype.constructor = FakeInput;


FakeInput.prototype.setValue = function ( text ) {
    // if ( this.$textVisibilityToggle !== null ) {
    //     this.$body.removeChild(this.$textVisibilityToggle);
    // }

    if ( this.size && text.length > this.size ) {
        text = text.substring(0, this.size);
    }

    if ( text ) {
        this.value = this.$body.textContent = text;
        this.$node.classList.remove('placeholder');
        if ( this.type === 'password' && !this.textVisible ) {
            this.$body.style.cssText = '-webkit-text-security: disc;';
        }
    } else if ( this.placeholder ) {
        this.$node.classList.add('placeholder');
        this.$body.style.cssText = '';
        this.$body.textContent = this.placeholder;
        this.value = '';
    } else {
        this.value = '';
    }

    this.$body.scrollLeft = 300000;

    // if ( this.$textVisibilityToggle !== null ) {
    //     this.$body.appendChild(this.$textVisibilityToggle);
    // }
};


FakeInput.defaultEvents = {
    keydown: function ( event ) {
        console.log(event.code);
        switch ( event.code ) {
            case keys.ok:
                this.emit('click');
                break;

            case keys.right:
                if ( this.$textVisibilityToggle !== null && !this.$textVisibilityToggle.focus ) {
                    this.$textVisibilityToggle.focus = true;
                    this.$node.classList.remove('focus');
                    if ( this.textVisible ) {
                        this.$textVisibilityToggle.className = 'text-visibility-toggle focus-visible';
                    } else {
                        this.$textVisibilityToggle.className = 'text-visibility-toggle focus-invisible';
                    }
                }
                break;


            case keys.left:
                if ( this.$textVisibilityToggle !== null && this.$textVisibilityToggle.focus ) {
                    this.$textVisibilityToggle.focus = false;
                    this.$node.classList.add('focus');
                    if ( this.textVisible ) {
                        this.$textVisibilityToggle.className = 'text-visibility-toggle visible';
                    } else {
                        this.$textVisibilityToggle.className = 'text-visibility-toggle';
                    }
                }
                break;

            default:
                break;
        }
    },
    focus: function () {
        if ( this.placeholder ) {
            this.$style.innerText = '#' + this.$node.id + ':before { color: #23548c; content: "' + this.placeholder + '";}';
        }
    },
    blur: function () {
        if ( this.placeholder ) {
            this.$style.innerText = '#' + this.$node.id + ':before { content: "' + this.placeholder + '";}';
        }

        if ( this.$textVisibilityToggle !== null && this.$textVisibilityToggle.focus ) {
            this.$textVisibilityToggle.focus = false;
            if ( this.textVisible ) {
                this.$textVisibilityToggle.className = 'text-visibility-toggle visible';
            } else {
                this.$textVisibilityToggle.className = 'text-visibility-toggle';
            }
        }
    },
    click: function () {
        var self = this;

        if ( this.$textVisibilityToggle !== null && this.$textVisibilityToggle.focus ) {
            this.textVisible = !this.textVisible;
            if ( this.value ) {
                if ( this.textVisible ) {
                    this.$textVisibilityToggle.className = 'text-visibility-toggle focus-visible';
                    this.$body.style.cssText = '';
                } else {
                    this.$textVisibilityToggle.className = 'text-visibility-toggle focus-invisible';
                    this.$body.style.cssText = '-webkit-text-security: disc;';
                }
            }
        } else {
            window.core.intent({
                action: 'keyboard',
                data: {
                    type: self.type,
                    language: getLang(),
                    value: self.value || self.scheme,
                    title: self.title
                },
                events: {
                    done: function ( event ) {
                        self.setValue(event.value);
                    },
                    close: function (  ) {
                        window.core.call('focus');
                    }
                }
            // eslint-disable-next-line no-unused-vars
            }, function ( error, context ) {
                console.log(error);
            });
        }
    }
};


module.exports = FakeInput;
